import { TOUR_TRANSLATIONS } from "../translations"

export const getPriceDiscountSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="price-discount-filters"]',
            title: t.priceDiscountFilters.title,
            content: t.priceDiscountFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="price-discount-offers"]',
            title: t.priceDiscountOffers.title,
            content: t.priceDiscountOffers.content,
        },
        {
            target: '[data-tour="price-discount-country-wise"]',
            title: t.priceDiscountCountryWise.title,
            content: t.priceDiscountCountryWise.content,
        },
        {
            target: '[data-tour="price-discount-candlestick"]',
            title: t.priceDiscountCandlestick.title,
            content: t.priceDiscountCandlestick.content,
        },
        {
            target: '[data-tour="price-discount-top-market"]',
            title: t.priceDiscountTopMarket.title,
            content: t.priceDiscountTopMarket.content,
        },
        {
            target: '[data-tour="price-discount-top-dispersion"]',
            title: t.priceDiscountTopDispersion.title,
            content: t.priceDiscountTopDispersion.content,
        },
    ]
}
